import { useState } from 'react';

import Header from './Header';
import SideBar from './SideBar';
import { UserInfoType } from '../../type/UserInfoType';

type HeaderAndSideBarPropsType = {
	userInfo: UserInfoType;
	setUserInfo: React.Dispatch<React.SetStateAction<UserInfoType>>;
};

/**
 * AppBarとDrawerを含めたコンポーネント
 */
export const HeaderAndSideBar = (props: HeaderAndSideBarPropsType) => {
	const { userInfo, setUserInfo } = props;

	const [drawerOpen, setDrawerOpen] = useState(false); // サイドバーの開閉状態を管理

	const handleDrawerOpen = () => {
		setDrawerOpen(true);
	};

	const handleDrawerClose = () => {
		setDrawerOpen(false);
	};

	return (
		<>
			<Header isLogin={userInfo.isLogin} handleDrawerOpen={handleDrawerOpen} userInfo={userInfo} setUserInfo={setUserInfo} />
			<SideBar drawerOpen={drawerOpen} handleDrawerClose={handleDrawerClose} userInfo={userInfo} />
		</>
	);
};
